import { request } from '../until/axios.js'

export function getLoginUser(username, password) {
  return request({
    url: '/order/getOrders',
    method: 'post',
    data: {
      username: username,
      password: password
    }
  })

}
export function getlogin(loginForm) {
  return request({
    url: '/login',
    method: 'post',
    data: loginForm
  })

}
export function getlogout() {
  return request({
    url: '/logout',
    method: 'post',
    data: {}
  })

}
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get',
    data: {}
  })

}



// WEBPACK FOOTER //
// ./src/api/login.js